<div class="content-inner">
	<span class="icon-spinner6 login-spin"></span>
</div>
